/* 布局 */
//前台
import Layout from "@views/layout";

const ordermanagepriceRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "ordermanageprice/list",
        name: "ORDERMANAGEPRICE",
        meta: {
            title: "墓穴续费订单",
            keepAlive:true
        },
        component: () => import("@views/business/ordermanageprice/index.vue"),
    },
        ],
};

export default ordermanagepriceRouter;
